(() => {
  const root = document.getElementById('bioline-line-intro');
  if (!root) return;
  const templates = new Map(Array.from(document.querySelectorAll('template[data-bioline-line]'), node => [node.dataset.biolineLine.toUpperCase(), node]));
  let current = root.dataset.currentLine.toUpperCase();
  let pending = false;
  const update = () => {
    pending = false;
    const values = new URLSearchParams(window.location.search).getAll('filter.p.m.custom.product_lijn').flatMap(value => value.split(',')).map(value => value.trim().toUpperCase()).filter(Boolean);
    const unique = [...new Set(values)];
    const next = unique.length === 1 && templates.has(unique[0]) ? unique[0] : '';
    if (next === current && root.hidden === !next) return;
    current = next;
    root.dataset.currentLine = next;
    if (next) root.replaceChildren(templates.get(next).content.cloneNode(true));
    else root.replaceChildren();
    root.hidden = !next;
  };
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  };
  update();
  window.addEventListener('popstate', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  const collection = document.querySelector('[data-instant-id="HHLsrX0bRnoCwIwk"]');
  if (collection) new MutationObserver(schedule).observe(collection, {subtree:true,childList:true,attributes:true,attributeFilter:['data-instant-state','data-instant-product-count']});
})();
